import React from 'react';
import PropTypes from 'prop-types';
import { Badge, InlineStack, useBreakpoints } from '@shopify/polaris';
import { APPS } from './api';

const AppTags = ({ codes }) => {
  const { smDown } = useBreakpoints();

  if (smDown) {
    return (
      <Badge tone={codes.length ? 'success' : undefined}>
        {`${codes.length}/${APPS.length} apps`}
      </Badge>
    );
  }

  return (
    <InlineStack gap="100" wrap>
      {APPS.map(({ code, name }) => (
        <Badge
          key={code}
          tone={codes.includes(code) ? 'success' : undefined}
          toneAndProgressLabelOverride={codes.includes(code) ? `${name}: shown` : `${name}: not shown`}
        >
          {code.toUpperCase()}
        </Badge>
      ))}
    </InlineStack>
  );
};

AppTags.propTypes = {
  codes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default AppTags;
